import * as Sentry from '@sentry/react';

export function handleError(e: any) {
  Sentry.captureException(e);
}
